import React, {Fragment, useEffect} from  "react" ;

const WieldySidebarSection = (props) =>
{
    return(
    <Fragment key='section'>
        <li className="dt-side-nav__item dt-side-nav__header" key='li1'>
            <span className="dt-side-nav__text">{props.title}</span>
        </li>
        { props.children }
    </Fragment>
)
}

export default WieldySidebarSection ;